/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Loader, Text } from '@mantine/core';
import { DatePickerProps, DatePicker } from '@mantine/dates';
import { isSameDay } from 'date-fns';
import { FC, useState } from 'react';
import { toUTC } from '../../Utils/dateUtils';
import { IconCalendar } from '@tabler/icons';

interface Props extends DatePickerProps {
  patchCallback: (val: Date) => Promise<unknown>;
  value: Date;
}

const BookitupDateInput: FC<Props> = ({ patchCallback, label, value, ...rest }) => {
  const [loading, setLoading] = useState(false);

  const onChange = async (val: Date) => {
    if (val && isSameDay(val, value)) {
      // Prevent update for the same day
      return;
    }
    // Send time in UTC for now :(
    setLoading(true);
    await patchCallback(toUTC(val));
    setLoading(false);
  };

  return (
    <DatePicker
      size="sm"
      clearable={false}
      icon={<IconCalendar size={20} />}
      rightSection={loading && <Loader size="xs" />}
      onChange={onChange}
      label={label && <Text size="xs">{label}</Text>}
      value={value}
      {...rest}
    />
  );
};

export default BookitupDateInput;
